import React, { memo, useState } from 'react';
import { withPopUp } from '@redlink/components/atoms';
import { PreviewLinkItem } from '@redlink/components/molecules';
import {
  DataEntryModalTemplate,
  LinkEditTemplate,
} from '@redlink/components/templates';

export const LinkEditPage = withPopUp(
  memo((props) => {
    const [{ logoName, title, url }, setItem] = useState({});
    return (
      <DataEntryModalTemplate>
        <LinkEditTemplate {...props} onChangeItem={(item) => setItem(item)} />
        <PreviewLinkItem logoName={logoName} title={title} externalUrl={url} />
      </DataEntryModalTemplate>
    );
  })
);
